export const DEFAULT_LINE_WIDTH = 1
export const DEFAULT_VERTEX_SIZE = 4
export const DEFAULT_VERTEX_ACTIVE_SCALE = 1.4
